import PropTypes from 'prop-types';
import styles from './FJTextToImageRatio.module.less';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import FJSideModel from '../../../../common/components/FJSideModel/FJSideModel';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import { useState } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import CheckIcon from '../../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJTextToImageRatio = ({ curRatio, changeRatio }) => {
    const [showSideModel, setShowSideModel] = useState(false);

    const handleClick = e => {
        e.stopPropagation();
        setShowSideModel(!showSideModel);
    };

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const handleChangeRatio = ratio => {
        changeRatio(ratio);
        setShowSideModel(false);
    };

    const curRatioObj = FJTextToImageDataConfig.RATIO_LIST.find(item => item.name === curRatio);

    return (
        <>
            <div className={styles.ratio_box}>
                <div className={styles.ratio_title}>{FJLocalStore._('aspect-ratio')}</div>
                <div className={styles.ratio_btu} onClick={handleClick} onMouseDown={handleOnMouseDown}>
                    <curRatioObj.icon className={styles.ratio_icon} />
                    {curRatioObj.name}
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>

            <FJSideModel
                position={{ top: 370, left: 478 }}
                active={showSideModel}
                className={styles.ratio_side_model}
                onClose={() => setShowSideModel(false)}
            >
                <div className={styles.model_ratio_title}>{FJLocalStore._('aspect-ratio')}</div>

                <FJVerticalScroller className={styles.ratio_list_box}>
                    {FJTextToImageDataConfig.RATIO_LIST.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.ratio_item,
                                    item.name === curRatioObj.name && styles.ratio_item_active,
                                )}
                                key={item.name}
                                onClick={() => handleChangeRatio(item)}
                            >
                                <item.icon className={styles.ratio_item_icon} />
                                <div className={styles.ratio_item_name}>{item.name}</div>
                                {item.name === curRatioObj.name && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </FJSideModel>
        </>
    );
};

FJTextToImageRatio.propTypes = {
    curRatio: PropTypes.string,
    changeRatio: PropTypes.func,
};
export default FJTextToImageRatio;
